interface TableItemProps {
  item: any;
}

// Função para converter data de "2025-12-17 18:52:45" para "17-12-2025 18:52:45"
const formatDateTime = (dateTimeString: string): string => {
  if (!dateTimeString) return "";

  const [datePart, timePart] = dateTimeString.split(" ");

  if (!datePart) return dateTimeString;

  const [year, month, day] = datePart.split("-");

  if (!year || !month || !day) return dateTimeString;

  return timePart
    ? `${day}-${month}-${year} ${timePart}`
    : `${day}-${month}-${year}`;
};

export const TableItem = ({ item }: TableItemProps) => {
  //   async function showErrors(id: any, code: any) {
  //     setLoadingModal(true);
  //     setModalErrorCode(code);
  //     setModalVisible(true);

  //     try {
  //       const response = await API.get(`/import/spreadsheet/errors/${id}`);

  //       const { data } = response.data;
  //       setDataModal(data);
  //     } catch (error) {
  //       console.log(error);
  //     }

  //   }

  return (
    <tr key={item.id}>
      <td>{item.name}</td>
      <td>{item.status}</td>

      <td>{formatDateTime(item.created_at)}</td>
      <td>{item.total}</td>
      {/* <td
        className={item.total_errors > 0 ? "text-purple text-click" : ""}
        onClick={() => {
          if (item.total_errors <= 0) return;
          showErrors(item.id, item.code_name);
        }}
      >
        {item.total_errors > 0
          ? `${item.total_errors} - ver mais`
          : item.total_errors}
      </td> */}
    </tr>
  );
};
